"use client";

import { remarkCitations } from "@/components/assistant-ui/citation";
import { defaultComponents } from "@/components/assistant-ui/markdown-text";
import { cn } from "@/lib/utils";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { MarkdownRendering } from "../markdown-renderer";

interface FileSummary {
  title: string;
  summary: string;
}

interface FileSummaryViewProps {
  contents: FileSummary;
  className?: string;
}

export function FileSummaryView({ contents, className }: FileSummaryViewProps) {
  if (!contents?.summary) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-theme-1">
        No summary available.
      </div>
    );
  }

  return (
    <article
      className={cn(
        "w-full max-w-3xl mx-auto",
        "px-6 py-8",
        "text-theme-0",
        className
      )}
    >
      <MarkdownRendering>{contents.summary}</MarkdownRendering>
    </article>
  );
}
